import { useFormik } from 'formik'
import { send } from 'ms-email/api/send-member-invitation'
import { useMemo } from 'react'
import { MembersTabTools as View } from 'ui-components'
import { getInviteLink, useClipboard } from 'utils'
import { object, string } from 'yup'

import { useIsWorkspaceOwner } from '~workspace/hooks/useIsWorkspaceOwner'
import { useCreateMemberInvitedUser } from '~workspace/queries/useCreateMemberInvitedUser'
import { useGetCurrentWorkspace } from '~workspace/queries/useGetWorkspaceById'

const MembersTabTools = () => {
  const [, copyToClipboard] = useClipboard()
  const { data } = useGetCurrentWorkspace()
  const isWorkspaceOwner = useIsWorkspaceOwner()
  const createMemberInvitedUser = useCreateMemberInvitedUser()
  const inviteLink = useMemo(() => {
    if (!data) return ''

    return getInviteLink({
      workspaceId: data.id,
      workspaceName: data.name,
      inviteId: data.inviteId
    })
  }, [data])

  const form = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: object({
      email: string()
        .email()
        .test('is-member', 'This email is already a member', (value) => {
          if (!value) return false

          return !data?.memberCollection?.items?.find(
            (member) => member?.user?.email === value
          )
        })
        .required()
    }),
    onSubmit: async (values, helpers) => {
      await send(
        {
          workspace: data
        },
        [values.email]
      )
      data?.id &&
        (await createMemberInvitedUser.mutateAsync({
          email: values.email,
          workspaceId: data.id
        }))
      helpers.resetForm()
    }
  })

  return (
    <View
      canInviteMember={isWorkspaceOwner}
      form={form}
      onCopyInviteLinkClick={() => copyToClipboard(inviteLink)}
    />
  )
}

export { MembersTabTools }
